import { useQuery } from "@tanstack/react-query";

import { getBeefFeedInformation, getBeefFeedInformationAdmin } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE, FOOTPRINTING_BEEF_FEED_INFORMATION } from "consts";

import { FootprintingBeefFeedInformation } from "models";

export const useGetFootprintingBeefFeedInformation = (primaryDataId: string, options?: { enabled?: boolean }) => {
  const isAdmin = getEnvironment().admin;

  return useQuery<FootprintingBeefFeedInformation[]>({
    queryKey: [FOOTPRINTING_BEEF_FEED_INFORMATION, primaryDataId, isAdmin],
    queryFn: () => (isAdmin ? getBeefFeedInformationAdmin(primaryDataId) : getBeefFeedInformation(primaryDataId)),
    enabled: options?.enabled !== false && !!primaryDataId,
    gcTime: DEFAULT_CACHE.gcTime,
    staleTime: DEFAULT_CACHE.staleTime,
  });
};
